import DocumentsLayout from "../../Views/Documents/Layout";
import Index from "../../Views/Documents/Index";
import Pending from "../../Views/Documents/Pending";
import Personal from "../../Views/Documents/Personal";
import Add from "../../Views/Documents/Add";
import Show from "../../Views/Documents/Show";

export default [
    {
        path:'/documents',
        component:DocumentsLayout,
        children:[
            {
                path:'',
                component:Index,
                name:'documents.index',
            },
            {
                path:'pending',
                component:Pending,
                name:'documents.pending.index',
            },
            {
                path:'personal',
                component:Personal,
                name:'documents.my.index',
            },
            {
                path:'add',
                component:Add,
                name:'documents.add.index',
            },
            {
                path:':uuid',
                component:Show,
                name:'documents.show',
            }
        ]
    },
];
